import type { VenueType } from '@hopin-team/api-hopin';

export const getVenueFlags = (venueType?: VenueType) => {
  return {
    isVirtualEvent: venueType === 'virtual',
    isHybridEvent: venueType === 'hybrid',
    isOnsiteEvent: venueType === 'onsite',
  };
};
